import ExcelJS from 'exceljs';

/**
 * Genera y descarga la plantilla oficial de carga masiva de reservas de Flujo App
 */
export const downloadBulkImportTemplate = async () => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'Flujo App';
  workbook.lastModifiedBy = 'Flujo App';
  workbook.created = new Date();

  const worksheet = workbook.addWorksheet('Plantilla Reservas', {
    views: [{ showGridLines: true }]
  });

  // Definición de columnas con encabezados, claves y anchos optimizados
  // Definición de columnas con encabezados, claves y anchos optimizados
  worksheet.columns = [
    { header: 'Nombre Cliente *', key: 'client_name', width: 22 },
    { header: 'Fecha Servicio *', key: 'scheduled_date', width: 16 },
    { header: 'Hora Servicio *', key: 'scheduled_hour', width: 14 },
    { header: 'Pasajero *', key: 'passenger', width: 24 },
    { header: 'Teléfonos pasajero', key: 'passenger_phone', width: 18 },
    { header: 'Cantidad Pasajeros', key: 'passenger_count', width: 16 },
    { header: 'Dirección origen *', key: 'pickup_address', width: 36 },
    { header: 'Dirección destino *', key: 'dropoff_address', width: 36 },
    { header: 'Dirección Parada 1', key: 'stop_1', width: 30 },
    { header: 'Dirección Parada 2', key: 'stop_2', width: 30 },
    { header: 'Solicitante *', key: 'requester', width: 24 },
    { header: 'Orden de servicio', key: 'external_ref', width: 18 },
    { header: 'Estado solicitud', key: 'status', width: 16 },
    { header: 'Área', key: 'area', width: 20 },
    { header: 'Código Centro de Costo', key: 'cost_center', width: 22 },
    { header: 'Motivo', key: 'reason', width: 22 },
    { header: 'N° de vuelo', key: 'flight_number', width: 14 },
    { header: 'Observación general', key: 'notes', width: 32 },
    { header: 'Valor total', key: 'estimated_price', width: 15 },
    { header: 'Costo proveedor', key: 'provider_cost', width: 15 },
    { header: 'Ciudad', key: 'city', width: 16 },
    { header: 'Conductor', key: 'driver', width: 22 },
    { header: 'Patente', key: 'plate', width: 12 },
  ];

  // Dar formato elegante al encabezado (Fila 1)
  const headerRow = worksheet.getRow(1);
  headerRow.height = 28;

  headerRow.eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '1E3A8A' } // Azul corporativo elegante
    };
    cell.font = {
      name: 'Segoe UI',
      size: 11,
      bold: true,
      color: { argb: 'FFFFFF' }
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true
    };
    cell.border = {
      top: { style: 'thin', color: { argb: 'CBD5E1' } },
      left: { style: 'thin', color: { argb: 'CBD5E1' } },
      bottom: { style: 'medium', color: { argb: '0F172A' } },
      right: { style: 'thin', color: { argb: 'CBD5E1' } }
    };
  });

  // Filas de ejemplo realistas
  const sampleRows = [
    {
      client_name: 'VIATOVIA',
      scheduled_date: '15/08/2026',
      scheduled_hour: '14:30',
      passenger: 'Carlos Mendoza',
      passenger_phone: '+56912345678',
      passenger_count: 1,
      pickup_address: 'Av. Providencia 1234, Providencia',
      dropoff_address: 'Aeropuerto Arturo Merino Benítez, Pudahuel',
      stop_1: '',
      stop_2: '',
      requester: 'Marta Fernández',
      external_ref: 'OS-9901',
      status: 'Creada',
      area: 'Gerencia General',
      cost_center: 'CC-1001',
      reason: 'Traslado Aeropuerto',
      flight_number: 'LA-501',
      notes: 'Espere en puerta de salidas internacionales',
      estimated_price: 35000,
      provider_cost: 25000,
      city: 'Santiago',
      driver: '',
      plate: ''
    },
    {
      client_name: 'TRAVEL SECURITY',
      scheduled_date: '16/08/2026',
      scheduled_hour: '09:00',
      passenger: 'Ana María Gómez',
      passenger_phone: '+56987654321',
      passenger_count: 2,
      pickup_address: 'Hotel Marriott, Vitacura',
      dropoff_address: 'Oficinas Centrales, El Bosque Norte 500, Las Condes',
      stop_1: 'Av. Apoquindo 3000, Las Condes',
      stop_2: '',
      requester: 'Javier Silva',
      external_ref: 'OS-9902',
      status: 'Creada',
      area: 'Servicios Terrestres',
      cost_center: 'CC-2045',
      reason: 'Reunión Ejecutiva',
      flight_number: '',
      notes: 'Llevar vehículo SUV ejecutivo',
      estimated_price: 42000,
      provider_cost: 30000,
      city: 'Santiago',
      driver: 'Juan Pérez',
      plate: 'KKL-12'
    }
  ];

  sampleRows.forEach((data) => {
    const row = worksheet.addRow(data);
    row.height = 22;
    row.eachCell((cell, colNumber) => {
      cell.font = { name: 'Segoe UI', size: 10 };
      cell.alignment = { vertical: 'middle' };
      cell.border = {
        top: { style: 'thin', color: { argb: 'E2E8F0' } },
        left: { style: 'thin', color: { argb: 'E2E8F0' } },
        bottom: { style: 'thin', color: { argb: 'E2E8F0' } },
        right: { style: 'thin', color: { argb: 'E2E8F0' } }
      };

      // Formato numérico para precios (columnas 19 y 20)
      if (colNumber === 19 || colNumber === 20) {
        cell.numFmt = '"$"#,##0';
        cell.alignment = { vertical: 'middle', horizontal: 'right' };
      }
      // Formato centrado para Fecha, Hora, Pax, Estado, OS, Vuelo, Patente
      if ([2, 3, 6, 12, 13, 17, 23].includes(colNumber)) {
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      }
    });
  });

  // Generar archivo Blob y descargar vía URL del navegador
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Plantilla_Carga_Reservas_FlujoApp_${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
